import { apiFetch } from "@/lib/api";

export interface PreEncapsulationHubSettingsPayload {
  unserializedWorkOrderFinishedSkus: string[];
}

export type PreEncapsulationHubSettingsResponse = PreEncapsulationHubSettingsPayload & {
  updatedAt: string | null;
};

export const PRE_ENCAPSULATION_HUB_SETTINGS_QUERY_KEY = ["manufacturing", "pre-encapsulation", "hub-settings"] as const;

export function fetchPreEncapsulationHubSettings(): Promise<PreEncapsulationHubSettingsResponse> {
  return apiFetch<PreEncapsulationHubSettingsResponse>("/api/manufacturing/pre-encapsulation/settings", {
    cache: "no-store",
  });
}

export function patchPreEncapsulationHubSettings(
  body: PreEncapsulationHubSettingsPayload,
): Promise<PreEncapsulationHubSettingsResponse> {
  return apiFetch<PreEncapsulationHubSettingsResponse>("/api/manufacturing/pre-encapsulation/settings", {
    method: "PATCH",
    body,
    cache: "no-store",
  });
}
